import { render } from "./pro-content.vue?vue&type=template&id=03c0ff84&scoped=true"
import script from "./pro-content.vue?vue&type=script&lang=js"
export * from "./pro-content.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-03c0ff84"

export default script